import React from 'react';
import styled from 'styled-components';

import NavigationBarLeft from './NavigationBarLeft';
import NavigationBarRight from './NavigationBarRight';

const NavigationBarContainer = styled.div`
  height: 60px;
  width: 100%;
  display: flex;
  background: ${props => props.theme.NEUTRAL_GREY};
`;

function SSONavigationBar() {
  return (
    <NavigationBarContainer>
      <NavigationBarLeft />
      <NavigationBarRight />
    </NavigationBarContainer>
  );
}

export default SSONavigationBar;
